/* global axios */
import ApiClient from './ApiClient';

class DealsAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  get(params = {}) {
    const mapping = {
      pipelineId: 'pipeline_id',
      stageId: 'stage_id',
      status: 'status',
      assigneeId: 'assignee_id',
      contactId: 'contact_id',
      page: 'page',
      perPage: 'per_page',
      q: 'q',
      label: 'label',
      customFieldKey: 'custom_field_key',
      customFieldValue: 'custom_field_value',
      minValue: 'min_value',
      maxValue: 'max_value',
      createdFrom: 'created_from',
      createdTo: 'created_to',
      sort: 'sort',
    };

    const queryParams = new URLSearchParams();
    Object.entries(mapping).forEach(([key, param]) => {
      if (params[key]) queryParams.append(param, params[key]);
    });

    const queryString = queryParams.toString();
    return axios.get(`${this.url}${queryString ? `?${queryString}` : ''}`);
  }

  show(dealId) {
    return axios.get(`${this.url}/${dealId}`);
  }

  // O CSV é processado no backend, de forma assíncrona.
  importFile(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  create(data) {
    // `conversation_id` nao e atributo do negocio: o backend usa o parametro de
    // topo para vincular a conversa ao negocio recem-criado.
    const { conversation_id: conversationId, ...deal } = data;
    return axios.post(this.url, { deal, conversation_id: conversationId });
  }

  update(dealId, data) {
    return axios.patch(`${this.url}/${dealId}`, { deal: data });
  }

  delete(dealId) {
    return axios.delete(`${this.url}/${dealId}`);
  }

  // Agendamento em massa: o backend escolhe a conversa de destino de cada
  // negocio e deduplica por contato, entao a acao e uma requisicao so.
  // `sort` segue a ordem do board: decide qual negocio fica com o contato
  // quando dois selecionados sao da mesma pessoa.
  scheduleMessages({ dealIds, sort, title, content, scheduledAt }) {
    return axios.post(`${this.url}/schedule_messages`, {
      deal_ids: dealIds,
      sort,
      title,
      content,
      scheduled_at: scheduledAt,
    });
  }

  move(dealId, stageId, position = null) {
    const payload = { stage_id: stageId };
    if (position !== null) payload.position = position;
    return axios.patch(`${this.url}/${dealId}/move`, payload);
  }

  assign(dealId, assigneeId) {
    return axios.patch(`${this.url}/${dealId}/assign`, {
      assignee_id: assigneeId,
    });
  }

  win(dealId) {
    return axios.patch(`${this.url}/${dealId}/win`);
  }

  lose(dealId, lostReason) {
    return axios.patch(`${this.url}/${dealId}/lose`, {
      lost_reason: lostReason,
    });
  }

  // Activities
  getActivities(dealId) {
    return axios.get(`${this.url}/${dealId}/activities`);
  }

  createActivity(dealId, data) {
    return axios.post(`${this.url}/${dealId}/activities`, {
      deal_activity: data,
    });
  }

  updateActivity(dealId, activityId, data) {
    return axios.patch(`${this.url}/${dealId}/activities/${activityId}`, {
      deal_activity: data,
    });
  }

  deleteActivity(dealId, activityId) {
    return axios.delete(`${this.url}/${dealId}/activities/${activityId}`);
  }

  completeActivity(dealId, activityId) {
    return axios.patch(
      `${this.url}/${dealId}/activities/${activityId}/complete`
    );
  }

  // Conversations
  getConversations(dealId) {
    return axios.get(`${this.url}/${dealId}/conversations`);
  }

  linkConversation(dealId, conversationDisplayId) {
    return axios.post(`${this.url}/${dealId}/conversations`, {
      conversation_id: conversationDisplayId,
    });
  }

  unlinkConversation(dealId, conversationDealId) {
    return axios.delete(
      `${this.url}/${dealId}/conversations/${conversationDealId}`
    );
  }
}

export default new DealsAPI();
